import { gql } from "@apollo/client";

export const AddStockCategory = gql`
  mutation AddStockCategory(
    $token: String!
    $category_name: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
  ) {
    AddStockCategory(
      token: $token
      category_name: $category_name
      customer_id: $customer_id
      user_details: $user_details
    )
  }
`;

export const UpdateStockCategory = gql`
  mutation UpdateStockCategory(
    $token: String!
    $category_id: ID!
    $user_details: SubscribedUser!
    $category_name: String!
  ) {
    UpdateStockCategory(
      token: $token
      category_id: $category_id
      user_details: $user_details
      category_name: $category_name
    )
  }
`;

export const DeleteStockCategory = gql`
  mutation DeleteStockCategory(
    $token: String!
    $category_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteStockCategory(
      token: $token
      category_id: $category_id
      user_details: $user_details
    )
  }
`;
